
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class OrderTeacherShareCalculationGrid extends Serenity.EntityGrid<OrderTeacherShareCalculationRow, any> {
        protected getColumnsKey() { return OrderTeacherShareCalculationColumns.columnsKey; }
        protected getDialogType() { return OrderTeacherShareCalculationDialog; }
        protected getIdProperty() { return OrderTeacherShareCalculationRow.idProperty; }
        protected getInsertPermission() { return OrderTeacherShareCalculationRow.insertPermission; }
        protected getLocalTextPrefix() { return OrderTeacherShareCalculationRow.localTextPrefix; }
        protected getService() { return OrderTeacherShareCalculationService.baseUrl; }

        private rowSelection: Serenity.GridRowSelectionMixin;

        constructor(container: JQuery) {
            super(container);
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }
        protected getColumns() {
            var columns = super.getColumns();
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(() => this.rowSelection));
            return columns;
        }
        get selectedItems() {
            return this.rowSelection.getSelectedKeys().map(x => this.view.getItemById(x));
        }

        /*protected getQuickFilters() {
            var filter = super.getQuickFilters();
            if (Authorization.hasPermission("Users:Franchisee") && !Authorization.hasPermission("Administration:Security")) {
                filter.splice(0, 2);
            }

            return filter;
        }*/

        protected getButtons() {
            var buttons = super.getButtons();
            buttons.splice(1, 3);

            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                title: 'Export',
                service: OrderTeacherShareCalculationService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            buttons.push({
                title: 'Teacher Payout',
                cssClass: 'print-button',
                onClick: () => {
                    var rowKeys = this.rowSelection.getSelectedKeys();
                    if (rowKeys.length == 0) {
                        Q.alert("Please select order first");
                        return;
                    }
                    else {
                        new TeacherPayoutDialog(this, true, rowKeys.toString()).dialogOpen();
                    }
                }
            });

            return buttons;
        }
    }
}